import { useEffect, useState } from 'react';

export const usePrefersReducedMotion = () => {
  const prefersReducedMotionQuery = '(prefers-reduced-motion: no-preference)';
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(true);

  useEffect(() => {
    const mediaQueries = window.matchMedia(prefersReducedMotionQuery);
    setPrefersReducedMotion(!window.matchMedia(prefersReducedMotionQuery).matches);

    const mediaQueryChange = (e: MediaQueryListEvent) => {
      setPrefersReducedMotion(!e.matches);
    };

    mediaQueries.addEventListener('change', mediaQueryChange);

    return () => {
      mediaQueries.removeEventListener('change', mediaQueryChange);
    };
  }, []);

  return prefersReducedMotion;
};
